import { Component, OnInit, ViewEncapsulation, Input } from "@angular/core";
import { CommonBaseComponent } from "../common-base.component";
import {
  MedicalSchool,
  Residency,
  Fellowship,
  BoardCertification
} from "../../../../shared/models/my-account-data.models";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { AddressComponent } from "../address/address.component";
import { AccountLookupComponent } from "../account-lookup/account-lookup.component";
import { AccountType, MemberType } from "../../../../shared/enums/data.enums";
import { GradDateComponent } from "../grad-date/grad-date.component";
import { Address } from "../../../../shared/models";

@Component({
  selector: "app-education-child",
  templateUrl: "./education-child.component.html",
  styleUrls: ["./education-child.component.scss"]
})
export class EducationChildComponent extends CommonBaseComponent {
 
  showAddress: boolean = false;
  ui_Speciality = this.dataService.uidata.Speciality;
  ui_BoardCertifications = this.dataService.uidata.BoardCertifications;

  get specialityid() {
    return this.educationChild.get("specialityid");
  }
  get boardcertificationid() {
    return this.educationChild.get("boardcertificationid");
  }

  get address() {
    return this.educationChild.get("address");
  }

  get accountLookUp() {
    return this.educationChild.get("accountLookUp");
  }

  get graduation() {
    return this.educationChild.get("graduation");
  }

  @Input() TITLE: string;

  @Input() accountType: AccountType;

  //@Input() educationChild: FormGroup;

  private _educationChild: FormGroup;
  get educationChild(): FormGroup {
    return this._educationChild;
  }

  @Input("educationChild")
  set educationChild(value: FormGroup) {
    
    this._educationChild = value;

    this.UpdateAddressValidations();
  }

  onAccountSelected(_showAddress: boolean) {
    this.showAddress = _showAddress;
    // this.showAddress = account != null && account.isManual;
    // if (!this.showAddress) {
    //   this.address.setValue(new Address());
    // }
    // this.educationChild.patchValue({
    //   id: account ? account.accountId : "",
    //   name: account ? account.name : ""
    // });
    this.UpdateAddressValidations();
  }

  UpdateAddressValidations() {
    if (this.accountType == AccountType.BOARDCERTIFICATION) {
      this.showAddress = false;
      
      return;
    }
    let id = this.educationChild.get("accountLookUp.id").value;
    this.showAddress =
      this.dataService.uidata.ManualAccounts.filter(a => a.accountId == id)
        .length > 0;
    if (!this.showAddress) {
      this.address.disable();
    } else {
      this.address.enable();
    }

    this.helperService.markFormGroupUnTouched(this.address as FormGroup);
  }

  static buildForm_MS(a: MedicalSchool, fb: FormBuilder, memberType: MemberType): FormGroup {  
    let dateInFuture: boolean = (memberType == MemberType.Student);
    let validate: boolean = true;
    return fb.group({
      accountLookUp: AccountLookupComponent.buildForm(a, fb, validate),
      contacteducationchildid: a.contactmedicalschoolid,
      graduation: GradDateComponent.buildForm(a.graduationdate, fb, dateInFuture, validate),
      //OPTIONAL//
      address: AddressComponent.buildForm(a.address, fb, validate),
      metadata: a.metadata
    });
  }

  static buildForm_R(a: Residency, fb: FormBuilder, memberType: MemberType): FormGroup {
    let dateInFuture: boolean = (memberType == MemberType.Resident || memberType == MemberType.Student);
    let validate: boolean = (memberType != MemberType.Student);
    return fb.group({
      accountLookUp: AccountLookupComponent.buildForm(a, fb, validate),

      contacteducationchildid: a.contactresidencyid,

      graduation: GradDateComponent.buildForm(a.graduationdate, fb, dateInFuture, validate),
      specialityid: [a.specialtyid, validate ? Validators.required: []],

      //OPTIONAL//
      address: AddressComponent.buildForm(a.address, fb, validate),
      metadata: a.metadata
    });
  }

  static buildForm_F(a: Fellowship, fb: FormBuilder, memberType: MemberType): FormGroup {

    let dateInFuture: boolean = (memberType == MemberType.Student || memberType == MemberType.Resident || memberType == MemberType.Fellow);
    let validate: boolean = memberType == MemberType.Fellow;
    return fb.group({
      accountLookUp: AccountLookupComponent.buildForm(a, fb, validate),
      contacteducationchildid: a.contactfellowshipid,

      graduation: GradDateComponent.buildForm(a.graduationdate, fb, dateInFuture, validate),

      //OPTIONAL//
      address: AddressComponent.buildForm(a.address, fb, validate),
      metadata: a.metadata
    });
  }

  static buildForm_B(a: BoardCertification, fb: FormBuilder, memberType: MemberType): FormGroup {
    let validate: boolean = false;
    return fb.group({
      boardcertificationid: a.id,
      contacteducationchildid: a.contactboardcertificationid,

      graduation: GradDateComponent.buildForm(a.expirationdate, fb, null, validate),

      // //OPTIONAL//
       address: AddressComponent.buildForm(null, fb, validate),
      // metadata: a.metadata
    });
  }
}
